import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { colorBlindModeSelector } from "../../store/slice/settings";
import { loadStyle } from "@euroland/react-high-chart";

export default function SeriesNoteColumnChart({ labels = {}, chartRef }) {
  const colorBlind = useSelector(colorBlindModeSelector);
  const [{ increasePattern, decreasePattern, offsetPattern }, setPatternColor] = useState({
    increasePattern: "",
    decreasePattern: "",
    offsetPattern: "",
  });

  useEffect(() => {
    if (!!chartRef.current?.container?.current) {
      const increasePattern = loadStyle(
        chartRef.current.container.current,
        "--chart-column-stack-increase"
      ).get();
      const decreasePattern = loadStyle(
        chartRef.current.container.current,
        "--chart-column-stack-decrease"
      ).get();
      const offsetPattern = loadStyle(
        chartRef.current.container.current,
        "--chart-column-stack-offset"
      ).get();
      setPatternColor({ increasePattern, decreasePattern, offsetPattern });
    }
  }, [colorBlind]);

  return (
    <>
      <div className="series-note-column-chart">
        <div className="series-note-column-chart__item series-note-column-chart__previous-period">
          <PatternColor className="series-note-column-chart__color" fill={offsetPattern} label={labels["invested"]} />
          <span className="series-note-column-chart__label">{labels["invested"]}</span>
        </div>
        <div className="series-note-column-chart__item">
          <PatternColor className="series-note-column-chart__color" fill={increasePattern} label={labels["increase"]} />
          <span className="series-note-column-chart__label"> {labels["increase"]}</span>
        </div>
        <div className="series-note-column-chart__item">
          <PatternColor className="series-note-column-chart__color" fill={decreasePattern} label={labels["decrease"]} />
          <span className="series-note-column-chart__label">{labels["decrease"]}</span>
        </div>
      </div>
    </>
  );
}

const PatternColor = ({ fill, className, label }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" >
      <rect
        aria-label={label}
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill={fill}
        stroke="#ffffff"
        strokeWidth="0"
        opacity="1"
        tabIndex="-1"
        role="img"
        style={{ outline: "none" }}
      ></rect>
    </svg>
  );
};
